import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import debounce from 'debounce'
import bem from 'easy-bem'
import throttle from 'lodash.throttle';
import ReactDOM from 'react-dom'

import './style.css'

const cn = bem('indiana-scroll-container')

const SCROLL_END_DEBOUNCE = 300

export default class ScrollContainer extends PureComponent {
  static propTypes = {
    vertical: PropTypes.bool,
    horizontal: PropTypes.bool,
    hideScrollbars: PropTypes.bool,
    activationDistance: PropTypes.number,
    children: PropTypes.node,
    onStartScroll: PropTypes.func,
    onScroll: PropTypes.func,
    onEndScroll: PropTypes.func,
    onClick: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
    ignoreElements: PropTypes.string,
    nativeMobileScroll: PropTypes.bool,
    stopPropagation: PropTypes.bool,
    zoom: PropTypes.number
  }

  static defaultProps = {
    nativeMobileScroll: true,
    hideScrollbars: true,
    activationDistance: 10,
    vertical: true,
    horizontal: true,
    stopPropagation: false,
    style: {},
    zoom: 100
  }

  constructor(props) {
    super(props)
    this.container = React.createRef()
    this.onEndScroll = debounce(this.onEndScroll, SCROLL_END_DEBOUNCE)

    // Is container scrolling now (for example by inertia)
    this.scrolling = false
    // Is scrolling started
    this.started = false
    // Is touch active or mouse pressed down
    this.pressed = false

    this.multiSelectOn = false

    this.scrollThrottle = throttle((e) => this.onScroll(e), 0.1)

    this.pressedEdge = false;
  }

  componentDidMount() {
    const {nativeMobileScroll} = this.props
    const container = this.container.current

    window.addEventListener('mouseup', this.onMouseUp)
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('touchmove', this.onTouchMove, {passive: false})
    window.addEventListener('touchend', this.onTouchEnd)
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);


    // due to https://github.com/facebook/react/issues/9809#issuecomment-414072263
    container.addEventListener('touchstart', this.onTouchStart, {passive: false})
    container.addEventListener('mousedown', this.onMouseDown, {passive: false})


    if (nativeMobileScroll) {
      // We should check if it's the mobile device after page was loaded
      // to prevent breaking SSR
      this.isMobile = this.isMobileDevice()

      // If it's the mobile device, we should rerender to change styles
      if (this.isMobile) {
        //this.forceUpdate()
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
    window.removeEventListener('mouseup', this.onMouseUp)
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('touchmove', this.onTouchMove)
    window.removeEventListener('touchend', this.onTouchEnd)
  }

  getElement() {
    return this.container.current
  }

  isMobileDevice() {
    return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
  }

  isDraggable(target) {
    const ignoreElements = this.props.ignoreElements
    if (ignoreElements) {
      const closest = target.closest(ignoreElements)
      return closest === null || closest.contains(this.getElement())
    } else {
      return true
    }
  }


  // Simulate 'onEndScroll' event that fires when scrolling is stopped 
  onEndScroll = () => {
    if (!this.pressed && this.started && !this.scrolling) {
      this.processEnd()
    }
  }

  onScroll = (e) => {
    const { zoom } = this.props
    const container = this.container.current  
    if ( e.clientX <= 300) { 
      container.scrollLeft = container.scrollLeft - 20;
      this.scrollThrottle(e)
    }
    if ( e.clientX >= 1600 ) { 
      container.scrollLeft = container.scrollLeft + 20
      this.scrollThrottle(e)
    }
    const titles = ReactDOM.findDOMNode(container).getElementsByClassName('ColumnTitle')

    const rowCountColumn = document.getElementsByClassName('RowCountColumnClass')
    const dayCountColumn = document.getElementsByClassName('DateRowClass')

    for(let i = 0; i < titles.length; i++) {
      const element = titles[i]
      //element.scrollTop = 0
    }

    let mapping = []

    for(let i = 0; i < titles.length; i++) {
      const element = titles[i]
      mapping.push(`${element.scrollTop}`)
    }


    const element = rowCountColumn[0]

    if(!!element && !!container) {
      element.scrollTop = container.scrollTop
    }

    const dayElement = dayCountColumn[0]


    if(!!dayElement && !!dayElement) {
      dayElement.scrollLeft = container.scrollLeft * (1/(zoom/100))
    }


    // Ignore the internal scrolls
    if (container.scrollLeft !== this.scrollLeft || container.scrollTop !== this.scrollTop) {
      this.processScroll(e)
      this.onEndScroll()
    }
  }


  onTouchStart = (e) => {
    const {nativeMobileScroll} = this.props
    if (this.isDraggable(e.target)) {
      if (nativeMobileScroll && this.scrolling) {
        this.pressed = true
      } else {
        const touch = e.touches[0]
        this.processClick(e, touch.clientX, touch.clientY)
        if (!nativeMobileScroll && this.props.stopPropagation) {
          e.stopPropagation()
        }
      }
    }
  }

  onTouchEnd = (e) => {
    const {nativeMobileScroll} = this.props
    if (this.pressed) {
      if (this.started && (!this.scrolling || !nativeMobileScroll)) {
        this.processEnd()
      } else {
        this.pressed = false
      }
      //this.forceUpdate()
    }
  };

  onTouchMove = (e) => {
    const {nativeMobileScroll} = this.props
    if (this.pressed && !this.multiSelectOn && (!nativeMobileScroll || !this.isMobile)) {
      const touch = e.touches[0]
      if (touch) {
        this.processMove(e, touch.clientX, touch.clientY)
      }
      e.preventDefault()
      if (this.props.stopPropagation) {
        e.stopPropagation()
      }
    }
  }


  onMouseDown = (e) => {

    if (!this.isDraggable(e.target)) {
      if (e.clientX <= 400 || e.clientX >= 1500 ) {
        this.pressedEdge = true;
      } 
      this.scrolling = true;
    e.preventDefault()
      if (this.props.stopPropagation) {
        e.stopPropagation()
      }
    }
    if (this.isDraggable(e.target)) {

      this.processClick(e, e.clientX, e.client)
      e.preventDefault()
      if (this.props.stopPropagation) {
        e.stopPropagation()
      }
    } 
    
  };

  onMouseMove = async(e) => {
    const container = this.container.current
    if (this.pressed && !this.multiSelectOn) {
      this.processMove(e, e.clientX, e.clientY)
      e.preventDefault()
      if (this.props.stopPropagation) {
        e.stopPropagation()
      }
    } else if(!!this.scrolling){
      if(!!this.pressedEdge) {
        if (e.clientX > 400 && e.clientX <1500) this.pressedEdge = false
      } else {
        this.scrollThrottle(e)
      }
    }
  }


  onKeyUp = (e) => {
    if(e.key === 'Control' || e.key === 'Meta' || e.key === 'Shift') {

      this.multiSelectOn = false
    }
  }

  onKeyDown = (e) => {
    if(e.key === 'Control' || e.key === 'Meta' || e.key === 'Shift') {

      this.multiSelectOn = true
    }
  }

  onMouseUp = (e) => {
    if (this.pressed) {
      if (this.started) {
        this.processEnd()
      } else {
        this.pressed = false
        //this.forceUpdate()
        if (this.props.onClick) {
          this.props.onClick(e)
        }
      }
      e.preventDefault()
      if (this.props.stopPropagation) {
        e.stopPropagation()
      }
    } 
    if (!!this.scrolling) this.scrolling = false;
  };

  processClick = (e, clientX, clientY) => {
    const container = this.container.current
    this.scrollLeft = container.scrollLeft
    this.scrollTop = container.scrollTop
    this.clientX = clientX
    this.clientY = clientY
    this.pressed = true
  }

  processStart = (e, changeCursor = true) => {
    const { onStartScroll } = this.props
    const container = this.container.current
    
    this.started = true
    // Add the class to change displayed cursor
    if (changeCursor) {
      //document.body.classList.add('indiana-dragging')
    }
    if (onStartScroll) {
      onStartScroll(container.scrollLeft, container.scrollTop, container.scrollWidth, container.scrollHeight)
    }
    //this.forceUpdate()
  }

  // Process native scroll (scrollbar, mobile scroll)
  processScroll = (e) =>  {     
    if (this.started) {
      const {onScroll} = this.props
      const container = this.container.current
      if (onScroll) {
        onScroll(container.scrollLeft, container.scrollTop, container.scrollWidth, container.scrollHeight)
      }
    } else {
      this.processStart(e, false)
    }
  }

  // Process non-native scroll
  processMove = async (e, newClientX, newClientY) => {    
    const {horizontal, vertical, activationDistance, onScroll} = this.props
    const container = this.container.current

    window.dispatchEvent(new CustomEvent('scroll'))
    if (!this.started || container.hasAttribute("disabled")) {

      if ((horizontal && Math.abs(newClientX - this.clientX) > activationDistance) || (vertical && Math.abs(newClientY - this.clientY) > activationDistance)) {
        this.clientX = newClientX
        this.clientY = newClientY
        this.processStart()
      }
    } else { 
      if (horizontal) {
        container.scrollLeft -= newClientX - this.clientX
      }
      if (vertical) {
        container.scrollTop -= newClientY - this.clientY
      }
      if (onScroll) {
        onScroll(container.scrollLeft, container.scrollTop, container.scrollWidth, container.scrollHeight)
      }
      this.clientX = newClientX
      this.clientY = newClientY
      this.scrollLeft = container.scrollLeft
      this.scrollTop = container.scrollTop
    }
  }

  processEnd = (e) => {
    const { onEndScroll } = this.props
    const container = this.container.current

    this.pressed = false
    this.started = false
    this.scrolling = false

    if (container && onEndScroll) {
      onEndScroll(container.scrollLeft, container.scrollTop, container.scrollWidth, container.scrollHeight)
    }
    //document.body.classList.remove('indiana-dragging')
    //this.forceUpdate()
  }

  scrollTo = (x, y) => {
    const current = this.container.current
    if(!!current && !!current.scrollTo) {
      current.scrollTo(x, y)
      window.dispatchEvent(new CustomEvent('scroll'))
    }
  }

  getBoundingClientRect = () => {
    if(this.container.current) {
      return this.container.current.getBoundingClientRect()
    }
    return {}
  }

  getValue = (name) => {
    if(this.container.current) {
      return this.container.current[name]
    }
  }

  render() {
    const {
      children, className, style, hideScrollbars
    } = this.props
    return (
      <div
        className={classnames(className, cn({
          'dragging': this.pressed && !this.multiSelectOn,
          'hide-scrollbars': hideScrollbars,
          'native-scroll': this.isMobile
        }))}
        style={style}
        ref={this.container}
        onScroll={this.onScroll}
      >
        {children}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/IndianaScroll/index.js